import { render, staticRenderFns } from "./PhoneVerificationView.vue?vue&type=template&id=cbef862a&scoped=true"
import script from "./PhoneVerificationView.vue?vue&type=script&lang=js"
export * from "./PhoneVerificationView.vue?vue&type=script&lang=js"
import style0 from "./PhoneVerificationView.vue?vue&type=style&index=0&id=cbef862a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbef862a",
  null
  
)

export default component.exports